import Fragment from 'ember-data-model-fragments/fragment';
import type { Type } from '@warp-drive/core/types/symbols';
import { attr } from '@warp-drive/legacy/model';

// Proto: events.OptionCount.
export default class OptionCount extends Fragment {
  declare [Type]: 'events/option-count';

  @attr('string', { defaultValue: '' })
  declare optionId: string;

  @attr('string', { defaultValue: '' })
  declare value: string;

  @attr('number', { defaultValue: 0 })
  declare count: number;
}
